// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BRO5H","largestCol":"styles_largestCol__1NbqU","smallestCol":"styles_smallestCol__LnIva"};